import React, { useState, useEffect } from "react";
import Button from "../../shared-components/Button/custom-button";
import { Dropdown } from "primereact/dropdown";
import { useDispatch, useSelector } from "react-redux";
import {
  createOrUpdateSurveyDetails,
  fetchLanguage,
} from "./details-store/details-actions";
import {
  checkOnCHangeData,
  fetchCurrentSurveyID,
  fetchCurrentSurveyName,
} from "../ProjectList/home-store/home-actions-creators";
import { useHistory } from "react-router-dom";
import { MultiSelect } from "primereact/multiselect";

const Details = () => {
  const dispatch = useDispatch();
  const { userLoginDetails } = useSelector((state) => state.login);
  const languageList = useSelector(
    (state) => state.surveyDetails?.getLanguageList
  );
  const languageOptions =
    languageList?.map((lang) => ({
      value: lang.language_id, // For selection handling
      label: lang.language_name, // For display
    })) || [];

  const history = useHistory();

  const [formValues, setFormValues] = useState({
    survey_id: 0,
    survey_name: "",
    supervisor_name: "",
    start_date: "",
    end_date: "",
    target_sample: "",
    budget: "",
    survey_status_id: 1,
    clone_survey_id: 0,
    Allow_back: 0,
    created_by: userLoginDetails.user_id,
    survey_languages: [],
  });

  const [validationErrors, setValidationErrors] = useState({
    survey_name: false,
    supervisor_name: false,
    start_date: false,
    end_date: false,
    target_sample: false,
    budget: false,
    survey_status_id: false,
    survey_languages: false,
  });

  const dropDownOptions = [
    { label: "Initiated", value: 1 },
    { label: "In Progress", value: 2 },
    { label: "Completed", value: 3 },
  ];

  useEffect(() => {
    const currentDate = new Date();
    const defaultEndDate = new Date();
    const defaultLanguageId = languageList?.find(
      (lang) => lang.language_name.toLowerCase() === "english"
    )?.language_id;
    defaultEndDate.setDate(currentDate.getDate() + 15);
    if (!languageList || languageList.length === 0) {
      dispatch(fetchLanguage());
    }

    setFormValues((prevState) => ({
      ...prevState,
      start_date: currentDate.toISOString().split("T")[0],
      end_date: defaultEndDate.toISOString().split("T")[0],
      survey_languages: defaultLanguageId ? [defaultLanguageId] : [], // Set default language if available
    }));
  }, [languageList]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue = value;

    // Convert to number for specific fields (like allow_back)
    if (name === "Allow_back") {
      newValue = type === "checkbox" ? (checked ? 1 : 0) : parseInt(value);
    }

    setFormValues((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));

    // Clear the validation error for the changed field
    setValidationErrors((prevState) => ({
      ...prevState,
      [name]: false,
    }));

    dispatch(checkOnCHangeData(true));
  };

  const handleLanguageChange = (e) => {
    // Keep as array of selected objects for the MultiSelect component
    const selectedLanguages = e.value;

    const englishLang = languageList?.find(
      (lang) => lang.language_name.toLowerCase() === "english"
    );
    const englishLangId = englishLang?.language_id;

    // Ensure English is always included
    const updatedLanguages = selectedLanguages.includes(englishLangId)
      ? selectedLanguages
      : [...selectedLanguages, englishLangId];

    setFormValues((prevState) => ({
      ...prevState,
      survey_languages: updatedLanguages,
    }));
    setValidationErrors((prevState) => ({
      ...prevState,
      survey_languages: false,
    }));
    dispatch(checkOnCHangeData(true));
  };
  const validateForm = () => {
    let validationErrors = {};

    // Check if any mandatory fields are empty
    if (formValues.survey_name.trim() === "") {
      validationErrors.survey_name = "Survey name is required.";
    }
    if (formValues.supervisor_name.trim() === "") {
      validationErrors.supervisor_name = "Project manager is required.";
    }

    // Check if other fields have valid values
    if (!formValues.start_date) {
      validationErrors.start_date = "Start date is required.";
    }
    if (!formValues.end_date) {
      validationErrors.end_date = "End date is required.";
    }
    if (!formValues.target_sample || formValues.target_sample < 0) {
      validationErrors.target_sample =
        formValues.target_sample < 0
          ? "Target sample cannot be less than 0."
          : "Target sample is required.";
    }
    if (!formValues.budget || formValues.budget < 0) {
      validationErrors.budget =
        formValues.budget < 0
          ? "Budget cannot be less than 0."
          : "Budget is required.";
    }
    if (!formValues.survey_status_id) {
      validationErrors.survey_status_id = "Status is required.";
    }

    if (formValues.end_date < formValues.start_date) {
      validationErrors.end_date =
        "End date should be greater than the start date.";
    }
    if (
      !formValues.survey_languages ||
      formValues.survey_languages.length === 0
    ) {
      validationErrors.survey_languages = "At least one language is required.";
    }

    return validationErrors;
  };

  const handleSave = async () => {
    const newValidationErrors = validateForm();

    // If there are any validation errors, update the state and return
    if (Object.keys(newValidationErrors).length > 0) {
      setValidationErrors(newValidationErrors);
      return;
    }

    try {
      const submitData = {
        ...formValues,
        survey_languages: formValues.survey_languages.join(","),
      };

      console.log("submitDataDetails", submitData);
      let surveyId = await dispatch(createOrUpdateSurveyDetails(submitData));
      dispatch(fetchCurrentSurveyID(surveyId));
      dispatch(fetchCurrentSurveyName(formValues.survey_name));
      const routePath = `/surveys/edit-survey/${surveyId}/design`;
      history.push(routePath);
      dispatch(checkOnCHangeData(false));
    } catch (error) {
      // Handle error if needed
      console.log(error);
    }
  };

  return (
    <div className="row">
      <style>
        {`
                .p-multiselect.p-multiselect-chip .p-multiselect-token {
                    padding: 0.20rem 0.20rem !important;
                }
            `}
      </style>
      <div className="col-1"></div>
      <div className="col-10">
        <div className="d-flex justify-content-between py-3">
          <div className="col-md-auto">
            <div
              className="row align-items-center"
              style={{ fontWeight: "bold", margin: 0 }}
            >
              <div className="col-md-auto">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    color: "#0D6EFD",
                  }}
                >
                  New Survey
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-auto" style={{ textAlign: "right" }}>
            <Button
              name="Save"
              label="Save"
              className="p-button-dark-blue"
              style={{
                backgroundColor: "#1F3BB3",
                fontSize: "12px",
                padding: "6px 5px",
              }}
              icon="pi pi-save"
              onClick={handleSave}
            />
          </div>
        </div>

        <div
          style={{
            border: "1px solid #d3caca",
            borderRadius: "10px",
            backgroundColor: "white",
            color: "black",
            margin: "10px",
          }}
        >
          <div className="row" style={{ padding: "20px" }}>
  <div className="col-sm-12 col-md-2">
    <label htmlFor="auto-generated">Code:</label>
    <input
      type="text"
      id="auto-generated"
      name="code"
      className="form-control"
      value="Auto Generated"
      readOnly
    />
  </div>
  <div className="col-sm-12 col-md-6">
    <label htmlFor="survey-name">
      Survey Name: <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="text"
      id="survey-name"
      name="survey_name"
      className={`form-control ${validationErrors.survey_name ? "is-invalid" : ""}`}
      value={formValues.survey_name}
      onChange={handleInputChange}
      placeholder="Please Enter Survey Name"
    />
    {validationErrors.survey_name && (
      <div className="invalid-feedback">{validationErrors.survey_name}</div>
    )}
  </div>
  <div className="col-sm-12 col-md-4">
    <label htmlFor="project-manager">
      Project Manager: <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="text"
      id="project-manager"
      name="supervisor_name"
      className={`form-control ${validationErrors.supervisor_name ? "is-invalid" : ""}`}
      value={formValues.supervisor_name}
      onChange={handleInputChange}
      placeholder="Please Enter Project Manager"
    />
    {validationErrors.supervisor_name && (
      <div className="invalid-feedback">{validationErrors.supervisor_name}</div>
    )}
  </div>
</div>

<div className="row" style={{ padding: "20px" }}>
  <div className="col-sm-12 col-md-2">
    <label htmlFor="target-sample">
      Target Sample: <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="number"
      id="target-sample"
      name="target_sample"
      className={`form-control ${validationErrors.target_sample ? "is-invalid" : ""}`}
      value={formValues.target_sample}
      onChange={handleInputChange}
      placeholder="Please Enter Target Sample"
    />
    {validationErrors.target_sample && (
      <div className="invalid-feedback">{validationErrors.target_sample}</div>
    )}
  </div>
  <div className="col-sm-12 col-md-2">
    <label htmlFor="budget">
      Budget: <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="number"
      id="budget"
      name="budget"
      className={`form-control ${validationErrors.budget ? "is-invalid" : ""}`}
      value={formValues.budget}
      onChange={handleInputChange}
      placeholder="Please Enter Budget"
    />
    {validationErrors.budget && (
      <div className="invalid-feedback">{validationErrors.budget}</div>
    )}
  </div>
  <div className="col-sm-12 col-md-2">
    <label htmlFor="start-date">
      Start Date: <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="date"
      id="start-date"
      name="start_date"
      className={`form-control ${validationErrors.start_date ? "is-invalid" : ""}`}
      value={formValues.start_date}
      onChange={handleInputChange}
    />
    {validationErrors.start_date && (
      <div className="invalid-feedback">{validationErrors.start_date}</div>
    )}
  </div>
  <div className="col-sm-12 col-md-2">
    <label htmlFor="end-date">
      End Date: <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="date"
      id="end-date"
      name="end_date"
      className={`form-control ${validationErrors.end_date ? "is-invalid" : ""}`}
      value={formValues.end_date}
      onChange={handleInputChange}
      min={formValues.start_date}
    />
    {validationErrors.end_date && (
      <div className="invalid-feedback">{validationErrors.end_date}</div>
    )}
  </div>

  <div className="col-sm-12 col-md-4 mb-2">
    <div className="row">
      <div className="col-sm-12 col-md-5">
 <label>
      Allow Back: <span style={{ color: "red" }}>*</span>
    </label>
    <div>
      <div className="form-check form-check-inline">
        <input
          className="form-check-input"
          type="radio"
          id="allow_back_yes"
          name="Allow_back"
          value={1}
          checked={formValues.Allow_back === 1}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="allow_back_yes">Yes</label>
      </div>
      <div className="form-check form-check-inline">
        <input
          className="form-check-input"
          type="radio"
          id="allow_back_no"
          name="Allow_back"
          value={0}
          checked={formValues.Allow_back === 0}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="allow_back_no">No</label>
      </div>
    </div>
      </div>
      <div className="col-sm-12 col-md-7">
    <label htmlFor="survey_status_id">Status:</label>
    <Dropdown
      className="form-control"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "33px",
      }}
      value={formValues.survey_status_id}
      options={dropDownOptions}
      onChange={(e) =>
        setFormValues((prevState) => ({
          ...prevState,
          survey_status_id: e.value,
        }))
      }
      placeholder="Select an option"
      disabled
    />
  </div>
    </div>
   
  </div>
  
</div>

<div className="row" style={{ padding: "20px" }}>
  <div className="col-sm-12 col-md-6">
    <label htmlFor="survey_languages">
      Language: <span style={{ color: "red" }}>*</span>
    </label>
    <MultiSelect
      value={formValues.survey_languages}
      options={languageOptions}
      onChange={handleLanguageChange}
      optionLabel="label"
      placeholder="Select Languages"
      display="chip"
      showSelectAll={false}
      className={`w-full md:w-20rem form-control ${validationErrors.survey_languages ? "is-invalid" : ""}`}
      style={{
        height: "calc(1.5em + 0.75rem + 2px)",
        minHeight: "35px",
        padding: "0.2rem 0.25rem",
        display: "flex",
        alignItems: "center",
      }}
      panelStyle={{ minWidth: "100%" }}
    />
    {validationErrors.survey_languages && (
      <div className="invalid-feedback">{validationErrors.survey_languages}</div>
    )}
  </div>

  <div className="col-sm-12 col-md-6">
    <label htmlFor="auto-generated">Survey URL:</label>
    <input
      type="text"
      id="auto-generated"
      name="code"
      className="form-control"
      value="Auto Generated"
      readOnly
    />
  </div>
</div>

        </div>
      </div>
      <div className="col-1"></div>
    </div>
  );
};

export default Details;
